// extracted by mini-css-extract-plugin
module.exports = {"box":"box--UdpPo","contact":"contact--sHDpE","card":"card--Pcc6f","first":"first--Y28Uq"};